(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8426],{

/***/ 8426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content0802": function() { return /* binding */ Content0802; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var _Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26832);
/* harmony import */ var _Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Content0802 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var image = (ref1 = payload === null || payload === void 0 ? void 0 : payload.preview) !== null && ref1 !== void 0 ? ref1 : {};
    var ref2;
    var position = (ref2 = payload === null || payload === void 0 ? void 0 : payload.position) !== null && ref2 !== void 0 ? ref2 : "left";
    var ref3;
    var ref4 = (ref3 = payload === null || payload === void 0 ? void 0 : payload.button) !== null && ref3 !== void 0 ? ref3 : {}, buttonText = ref4.buttonText, link = ref4.link;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3___default().block), (_Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[position]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading4 */ .k8, {
                                className: (_Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                                color: "light",
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .PageLink */ .H_, {
                                link: link,
                                className: (_Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3___default().button),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                        color: "light",
                                        appearance: "bigger",
                                        className: (_Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3___default().label),
                                        children: buttonText
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3___default().preview),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .ImageLite */ .NH, {
                            image: image,
                            className: (_Content0802_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image)
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content0802);


/***/ }),

/***/ 26832:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content0802_wrapper__3iWAl","block":"Content0802_block__8wLns","preview":"Content0802_preview__UVivp","image":"Content0802_image__mn6mk","left":"Content0802_left__drCQ_","right":"Content0802_right__vmIYP","content":"Content0802_content__xPtua","title":"Content0802_title__mboqa","link":"Content0802_link__HmTC5","button":"Content0802_button__ho9TH","label":"Content0802_label__Qk2Vo"};

/***/ })

}]);